import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { BatteryProposalExtendedWarrantiesDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useBatteryProposalExtendedWarranties(
  proposalId: string | undefined,
): UseQueryResult<BatteryProposalExtendedWarrantiesDto> {
  return useQuery({
    queryKey: queryKeys.batteryProposal.extendedWarranties(proposalId ?? ``),
    queryFn: () => {
      if (!proposalId) {
        throw new Error(`Battery-Only Proposal id is required`)
      }

      return batteryProposalService.getExtendedWarranties(proposalId)
    },
    enabled: Boolean(proposalId),
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
